import { ArticleBase } from '../article/article.component';
import { Component, OnInit } from '@angular/core';
import { escape } from 'querystring';

@Component({
  selector: 'app-article-content12',
  templateUrl: './article-content12.component.html',
  styleUrls: ['./article-content12.component.css']
})
export class ArticleContent12Component implements OnInit {

  articleOne : ArticleBase;

  constructor() { }

  ngOnInit() {
    this.articleOne = { 'title' : 'ATmega328P Fast PWM Example',
                        'lastUpdated' : 'Febuary 17 2022' };
  }

}
